import React from "react";
import "./HouseingTransform.css";

const FacadeExternalCleaningTransform = () => {
  return (
    <section className="workplace-cta-section">
      <div className="workplace-cta-container">
        <h2 className="workplace-cta-title">
          Enhance Your Building&apos;s Appearance
        </h2>

        <p className="workplace-cta-text">
          Get professional facade cleaning services to maintain your building&apos;s
          pristine exterior and protect your investment
        </p>

        <a
          href="https://wa.me/919899811123?text=Facade%20External%20Cleaning"
          target="_blank"
          rel="noopener noreferrer"
          className="workplace-cta-btn"
        >
          Get a Facade Cleaning Quote →
        </a>
      </div>
    </section>
  );
};

export default FacadeExternalCleaningTransform;
